import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as contactActions from '../../actions/contact';
import { Link } from 'react-router-dom';
import Header from '../Header';

class Request extends React.Component {
  state = {
    name: '',
    email: '',
    message: '',
    errors: [],
    sent: false
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  request = e => {
    e.preventDefault();
    let errors = [];
    if (this.state.email === '') {
      errors.push('Email address is required');
    }

    if (errors.length < 1) {
      return this.props._contact.sendContact(this.state.email, this.state.message, this.state.name)
        .then(res => this.setState({ sent: true }))
        .catch(err => this.setState({ sent: true }));
    }

    this.setState({ errors: errors });
  }

  render() {
    return (
      <section className="hero home is-fullheight">
        <Header {...this.props} />
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-3">Request an Access Code</h1>
            <h2 style={{ color: '#fff', padding: '0' }} className="subtitle">Already have a code? <Link to="/access" style={{ color: '#fff' }}>Click here</Link></h2>
            <div className="columns">
              <div className="column is-4">
                <p className="content has-text-left">
                  <ul>
                    <li>The Collaborative care Initiative was founded by Gary Sachs, MD as a private company to help clinicians and patients work together. This website is intended as a means of supplying methods, tools and informational resources members can use to implement a collaborative care approach with their care providers. CCI encourages an individualized systematic approach to care which combines shared clinical decision making with measure-based guidance.</li>
                    <li>Many patients with conditions like mood and anxiety disorders and their supports often find traditional clinical service models frustrating and are looking for more effective ways to work with their care providers.</li>
                    <li>There is no single right way to practice collaborative care. The CCI model is designed to facilitate patient-clinician collaboration as they work together to establish concordance and optimize an individual’s care. CCI principles emphasize respect for the differing preferences and needs of patients. As a member you can explore the site and choose options best suited to you. You may want to download a few tools and try “doing it on your own”, subscribe to electronic tools developed by CCI, and/or use links to other resources. We encourage you to explore and get started with the option you find most appealing.</li>
                  </ul>
                </p>
              </div>
              <div className="column is-4">
                <p className="content has-text-left">
                  <ul>
                    <li><strong style={{ color: '#fff' }}>Initiative</strong> - become a more active agent in your care.</li>
                    <li><strong style={{ color: '#fff' }}>Speak so clinicans will listen</strong> - Pre-assessment reports use quantitative measures to amplify your voice and make it easier for the care team to hear you.</li>
                    <li><strong style={{ color: '#fff' }}>Improve your knowledge</strong> - Learn about concordance, collaborative care plans, and new resources.</li>
                  </ul>
                </p>
              </div>
              <div className="column is-4">
                {this.state.errors.map((e, i) => <div key={i} className="notification is-warning">{e}</div>)}
                {this.state.sent && <div className="notification is-success">
                  Your request has been received and someone will be in touch shortly!
                </div>}
                <form onSubmit={this.request}>
                  <div className="field has-text-left">
                    <label className="label" htmlFor="name">Name</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="name"
                        onChange={this.onChange}
                        value={this.state.name} />
                    </div>
                  </div>

                  <div className="field has-text-left">
                    <label className="label" htmlFor="email">Email</label>
                    <div className="control">
                      <input
                        type="email"
                        className="input"
                        name="email"
                        onChange={this.onChange}
                        value={this.state.email}
                      />
                    </div>
                  </div>

                  <div className="field has-text-left">
                    <label className="label" htmlFor="message">My Treatment Goals:</label>
                    <div className="control">
                      <textarea value={this.state.message} name="message" onChange={this.onChange} className="textarea"></textarea>
                    </div>
                  </div>

                  <button type="submit" className="button is-info">Request</button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    _contact: bindActionCreators(contactActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Request);



// WEBPACK FOOTER //
// ./src/components/pages/Request.js